import vue from 'vue'
import { actionDelete } from '@/components/tools'
const that = vue.prototype
export default {
  className: 'couponIssues',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '名称不可为空'
      ]
    },
    {
      name: 'type',
      validators: [
        (val) => val ? null : '类型不可为空'
      ]
    }, {
      name: 'users',
      note: '发放的用户',
      listWhere: (where) => {
        where.accountCategory = 'countyAccount'
      },
      validators: [
        (val) => val ? null : '发放的用户不可为空',
        (val) => {
          return val.length ? null : '发放的用户不可为空'
        }
      ]
    },
    {
      name: 'parValue',
      note: '面值',
      validators: [
        (val) => val ? null : '面值不可为空',
        (val) => val <= 0 ? '面值输入不正确' : null
      ]
    }, {
      name: 'conditionsUse',
      width: 150,
      note: '限额',
      validators: [
        (val) => val ? null : '限额不可为空',
        (val) => val <= 0 ? '限额输入不正确' : null
      ]
    }
  ],
  search: [
    'name',
    'type'
  ],
  action: {
    create: {
      text: '发放优惠券'
    },
    delete: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看优惠券发放记录',
      component: 'viewPage'
    },
    deleteRecord: {
      type: 'row',
      text: '删除记录',
      callback: actionDelete
    }
  },
  hooks: {
    /**
    * 保存数据前判断
    * @date: 2020/3/11
    */
    async beforeSave (options) {
      let data = options.data
      // 根据选择的用户发放优惠券
      let promiseArr = data.users.map(async (s, index) => {
        return that.$tkParse.post('/classes/vouchers', {
          type: data.type,
          user: data.users[index],
          parValue: Number(data.parValue),
          conditionsUse: Number(data.conditionsUse),
          status: 'notUsed',
          name: data.name,
          isDeleted: false
        })
      })
      let res = Promise.all(promiseArr).then(() => {
        return 'success'
      }).catch((e) => {
        return 'fail'
      })
      if (await res === 'fail') {
        throw that.$notification['error']({
          message: '网络错误',
          description: '发放失败'
        })
      }
    }
  }
}
